var map = {
  "./cs.json": [
    "UM",
    [
      "y1"
    ]
  ],
  "./en.json": [
    "O9T",
    [
      "8ze"
    ]
  ],
  "./pl.json": [
    "j5",
    [
      "h1"
    ]
  ],
  "./ru.json": [
    "dKc",
    [
      "b2"
    ]
  ],
  "./tr.json": [
    "Qpm",
    [
      "um"
    ]
  ],
  "./ja.json": [
    "QTR",
    [
      "ues"
    ]
  ],
  "./zh.json": [
    "mf8",
    [
      "o66"
    ]
  ],
  "./pt-br.json": [
    "tlH",
    [
      "70t"
    ]
  ],
  "./de.json": [
    "aJo",
    [
      46
    ]
  ],
  "./es.json": [
    "a2C",
    [
      "o"
    ]
  ],
  "./fr.json": [
    "fXZ",
    [
      "pu"
    ]
  ],
  "./it.json": [
    "fu5",
    [
      "ly"
    ]
  ],
  "./ko.json": [
    "Cm4",
    [
      "ss"
    ]
  ],
  "./pt.json": [
    "pWv",
    [
      "jx"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "IZQ";
module.exports = __rspack_async_context;
